import documentReady from 'document-ready';
import Ajax from 'legacy/ajax';
import $ from 'legacy/jquery';

documentReady(() => {
  function init() {
    $('.add-note').on('click', toggleNote);
    $('.submit-button').on('click', submit);
    $('.radio').on('click', toggleRadio);
    $('.single-select').on('change', toggleSingleSelect);
    $('.free-form-checkbox').on('change', toggleFreeFormText);
  }

  function submit() {
    if (isFormValid()) {
      $('.error').hide();
      Ajax.submit({
        formSelector: 'form',
      });
    } else {
      $('.error').show();
    }
  }

  function toggleNote() {
    // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
    const $button = $(this);
    const $question = $button.parents('.question');

    if ($button.hasClass('add-note')) {
      showNote($question);
      $button.removeClass('add-note').addClass('delete-note');
      $button.text('Cancel');
    } else {
      hideNote($question);
      $button.addClass('add-note').removeClass('delete-note');
      $button.text('Comment');
    }
  }

  function hideNote($question: any) {
    const $note = $question.find('.note').slideUp();
    $note.find('textarea').val(null);
  }

  function showNote($question: any) {
    $question.find('.note').slideDown();
  }

  function toggleRadio() {
    // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
    const $choice = $(this);
    // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
    const $container = $(this).parents('.question');
    // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
    const $actualRadio = $(this).find('input');

    $actualRadio.prop('checked', true);

    $container.find('.choice').removeClass('selected');
    $choice.addClass('selected');
    return false;
  }

  function isFormValid() {
    return allRequiredQuestionsAnswered() && atLeastOneQuestionAnswered();
  }

  function atLeastOneQuestionAnswered() {
    let isValid = false;

    $('.question').each(function () {
      // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
      const $this = $(this);
      if (
        $this.find('.choice.radio.selected').length === 1 ||
        $this.find('textarea').val()
      ) {
        isValid = true;
        return false;
      }
    });

    return isValid;
  }

  function allRequiredQuestionsAnswered() {
    let requiredChosen = true;

    $('.demographic-question.required').each(function () {
      // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
      const $this = $(this);
      const freeFormInput = $this.find('.free-form-input:enabled');
      // if a free form box has a non-empty value and is enabled OR a non-free form box is checked
      requiredChosen =
        $this.find('.answer-option-checkbox:checked').length > 0 ||
        (freeFormInput.length > 0 && freeFormInput.val().length > 0);

      if (!requiredChosen) {
        return false;
      }
    });

    return requiredChosen;
  }

  function toggleSingleSelect() {
    // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
    const $checkbox = $(this);
    if (!$checkbox.is(':checked')) {
      return;
    }

    const $question = $checkbox.parents('.question');
    const $opposingCheckboxes = $question
      .find('input[type=checkbox]:checked')
      .not($checkbox);

    $opposingCheckboxes.prop('checked', false);
    $opposingCheckboxes.change();
  }

  function toggleFreeFormText() {
    // @ts-expect-error - TS2683 - 'this' implicitly has type 'any' because it does not have a type annotation.
    const $checkbox = $(this);
    const checked = $checkbox.is(':checked');
    const $wrapper = $checkbox.parent().next('.free-form-text');
    const $textField = $wrapper.find('input[type=text]');

    $textField.val('');
    $textField.enable(checked);
    $wrapper.toggle(checked);

    if (checked) {
      $textField.focus();
    }
  }

  init();
});
